import { useTranslation } from 'react-i18next'

import type { OrderSummaryRoot } from '@repo/sdk'

import type { StatusConfig } from '../../components/StatusBadge'

type OrderStatus = OrderSummaryRoot['status']

export function useOrderStatusConfig(): Record<OrderStatus, StatusConfig> {
  const { t } = useTranslation()

  return {
    CREATED: { color: 'default', label: t('common.status.created') },
    PAYMENT_REQUESTED: { color: 'orange', label: t('common.status.paymentRequested') },
    AWAITING_REPAYMENT: { color: 'yellow', label: t('common.status.awaitingRepayment') },
    PAID: { color: 'blue', label: t('common.status.paid') },
    SHIPPED: { color: 'purple', label: t('common.status.shipped') },
    DELIVERED: { color: 'cyan', label: t('common.status.delivered') },
    CONFIRMED: { color: 'green', label: t('common.status.confirmed') },
    CANCELLED: { color: 'red', label: t('common.status.cancelled') },
    RETURNED: { color: 'volcano', label: t('common.status.returned') },
    EXPIRED: { color: 'default', label: t('common.status.expired') },
  }
}
